import { formatAmount } from "../../utils";
import { ISubnetDetailResponse } from "../../utils/types";
import clsx from "clsx";

const Item = ({ label, value, isLast = false }: { label: string, value: string | React.ReactNode, isLast?: boolean }) => {
  return <div className={clsx("flex w-full justify-between gap-[90px] text-[14px] pb-[16px]", !isLast && "border-b border-black/10 dark:border-white/10")}>
    <div className="font-normal text-black/50 dark:text-white/50 truncate">{label}</div>
    <div className="font-medium text-black dark:text-white">{value}</div>
  </div>
}

const SkeletonItem = ({ label, isLast = false }: { label: string, isLast?: boolean }) => {
  return (
    <div className={clsx("flex w-full justify-between gap-[90px] text-[14px] pb-[16px]", !isLast && "border-b border-black/10 dark:border-white/10")}>
      <div className="font-normal text-black/50 dark:text-white/50 truncate">{label}</div>
      <div className="font-medium text-black dark:text-white">
        <div className="h-4 bg-black/10 dark:bg-white/10 rounded animate-pulse w-16"></div>
      </div>
    </div>
  )
}

const SubnetDetailOverview = ({ subnet }: { subnet?: ISubnetDetailResponse | null }) => {
  if (!subnet) {
    return (
      <div className="flex flex-col gap-[16px] pt-[16px] w-[256px]">
        <SkeletonItem label="Market Cap" />
        <SkeletonItem label="Volume 24h" />
        <SkeletonItem label="FDV" />
        <SkeletonItem label="Circulating Supply" />
        <SkeletonItem label="TAO in Pool" />
        <SkeletonItem label="Alpha in Pool" />
        <SkeletonItem label="Emission" />
        <SkeletonItem label="Price" isLast />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-[16px] pt-[16px]">
      <Item label="Market Cap" value={`${formatAmount(subnet.market_cap?.toString() || "0")}`} />
      <Item label="Volume 24h" value={`${formatAmount(subnet.volume_24h?.toString() || "0")}`} />
      <Item label="FDV" value={`${formatAmount(subnet.fdv_tao?.toString() || "0")}`} />
      <Item label="Circulating Supply" value={`${formatAmount(subnet.circulating_supply?.toString() || "0")}`} />
      <Item label="TAO in Pool" value={`τ${formatAmount(subnet.tao_in_pool?.toString() || "0")}`} />
      <Item label="Alpha in Pool" value={(
        <div className="flex items-center">
          <span>{subnet.symbol}</span>
          <span>{formatAmount(subnet.alpha_in_pool?.toString() || "0")}</span>
        </div>
      )} />
      <Item label="Emission" value={`${formatAmount((subnet.emission * 100).toString() || "0")}%`} />
      <Item label="Price" value={`${formatAmount(subnet.price?.toString() || "0", true)}`} isLast />
    </div>
  );
};

export default SubnetDetailOverview;